import React, { Fragment } from 'react'
import { Loading } from '@myxplor/ui'

import RecordHeading from '../../../ui/record-heading'
import { toSubmissionsFromPayments } from '../../../navigate'
import PaymentsEmpty from './empty'
import PaymentsList from './list'
import SubmissionsLink from './submissions-link'

const PaymentsView = ({ record = {}, base_url, payments }) => (
  <Fragment>
    <RecordHeading record={record.child}>
      <SubmissionsLink base_url={toSubmissionsFromPayments(base_url)} session_summary={record} />
    </RecordHeading>

    {payments.loading ? (
      <Loading>Loading matching government payments</Loading>
    ) : payments.data.length === 0 ? (
      <PaymentsEmpty />
    ) : (
      <PaymentsList records={payments.data} />
    )}
  </Fragment>
)

export default PaymentsView



// WEBPACK FOOTER //
// ./src/payments/details/views/index.jsx